import PropTypes from 'prop-types';

const dataShape = PropTypes.shape({
  width: PropTypes.number,
  height: PropTypes.number,
  url: PropTypes.string,
});

const assetShape = PropTypes.shape({
  urn: PropTypes.string,
  mediaType: PropTypes.oneOf(['image', 'video', 'document', 'audio']),
  source: PropTypes.shape({
    large: dataShape,
    medium: dataShape,
    original: dataShape,
    small: dataShape,
    thumb: dataShape,
  }),
});

export {
  assetShape,
};
